import { render, staticRenderFns } from "./volunteerActivity.vue?vue&type=template&id=379665ec&scoped=true"
import script from "./volunteerActivity.vue?vue&type=script&lang=js"
export * from "./volunteerActivity.vue?vue&type=script&lang=js"
import style0 from "./volunteerActivity.vue?vue&type=style&index=0&id=379665ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379665ec",
  null
  
)

export default component.exports